import React, { useState, useEffect } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { Link, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import Web3Intraction from "utils/web3Intraction";
import { converCryptoToDollar } from "helpers/constants";
// Hooks
import useMetaMask from "hooks/metsmask";

// Store
import {
  postIpfsFile as uploadFileIPFS,
  uploadFile,
  // getCollections,
  getCategories,
  postItem,
  putItem,
  getArtByUserIdRequest,
  getSubCategories,
  getNewCollectionByEmailStart,
  addTransaction,
  addParticularOwner,
  addSellItem,
  addArtworkForm,
} from "store/actions";
import { Oval } from "react-loader-spinner";
import Tiff from "tiff.js";
import CertificateofAuthenticity from "./CertificateofAuthenticity";
import { arrayIncludes } from "@mui/x-date-pickers/internals/utils/utils";
// import { event } from "jquery";
export default function Createnft(props) {
  const [rows, setRows] = React.useState([{ sizeone: '', sizeTwo: '' }]);
  const [artWorkId, setArtWorkId] = useState("")

  const handleInputChange = (e, index) => {
    const values = [...rows];
    if (e.target.name === 'sizeone') {
      values[index].sizeone = e.target.value;
    } else {
      values[index].sizeTwo = e.target.value;
    }
    setRows(values);
  };
  const handleAddRow = () => {
    if (rows.length > 3) {
      // alert('Cant add more then 4 canvas')
      return toastr.warning("Only four entries are allowed");
    } else {

      setRows([...rows, { sizeone: '', sizeTwo: '' }]);
    }
  };

  const handleRemoveRow = (index) => {
    const values = [...rows];
    values.splice(index, 1);
    setRows(values);
  };

  // const handleSubmit = () => {
  //   console.log(rows);
  // };
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (edition) => {

    // setIsChecked(!isChecked);
    // setChecked((prevState) => {
    //   const newState = !prevState;
    // if (newState) {
    //   // openModal();
    //   setshowAuthenticity(true);
    // } else {
    //   setshowAuthenticity(false);
    // }
    // return newState;
    // });
  };

  const [physicalprint, setPhysicalprint] = useState()
  const showDetails = (data) => {
    if (data === "Showdata") {
      setPhysicalprint()
    }
    else {

    }
    // setIsDegital(data)
    // setPrintInfo()
  }

  const [showAuthenticity, setshowAuthenticity] = useState(false);
  // Function to open the modal
  const Authenticity = () => {
    // if(!previewart){
    // return toastr.error("Please select Art")
    // }
    setshowAuthenticity(!showAuthenticity);
  };
  const handleEditionChange = (value) => {
    // setChecked((prevState) => {
    //   const newState = !prevState;
    //   // if (newState) {
    //   //   setshowAuthenticity(true);
    //   // } else {
    //   //   setshowAuthenticity(false);
    //   // }
    //   return newState;
    // });
    fields?.edition === "Open Edition" ? setIsChecked(true) : setIsChecked(false);
    setFields((p) => ({ ...p, edition: value }))
  };
  // Function to close the modal
  // const closeAuthenticity = () => {
  //   setshowAuthenticity(!showAuthenticity);
  // };

  const [menu, menuopen] = useOutletContext();
  useEffect(() => {
    menu(false)
  }, [menu])
  const location = useLocation();
  const [resale, setresale] = useState();
  useEffect(() => {
    setresale(location.state);
  }, [location]);
  const { email } = useSelector((state) => state?.Login?.user);
  const wallAddress = localStorage.getItem("walletAddress");
  const { itemId, resellId } = useParams();
  const [search, setSearch] = useState('')
  // const id = queryParams?.get("id");
  const [approveArt, setApproveArt] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hooks = useMetaMask();
  const { user, settings } = useSelector((state) => state?.Login);
  const { item, loading } = useSelector((state) => state?.items);
  const [collectionsList, setCollectionsList] = useState([]);

  const fileLoading = useSelector((state) => state?.File?.loading);

  const [usdPrice, setUsdPrice] = useState(0);
  const [maticmainnet, setMaticmainnet] = useState(false);

  const [fieldsError, setfieldsError] = useState();

  const [saletype, setsaletype] = useState("fixed");
  const maxCharacterCount = 150;
  const [textDis, settextDis] = useState("");
  const [descLen, setDescLen] = useState(0)

  const [collectionfilter, setcollectionfilter] = useState({
    limit: 100,
    orderBy: "",
    order: "",
    page: 1,
    author: user?._id,
  });
  let [fields, setFields] = useState({
    image_id: "",
    image_url: "",
    support_docs: "",
    relatedImages: "",
    noofcopies: 1,
    token_hash: "",
    description: "",
    name: "",
    subtitle: "",
    typeofsale: "fixed",
    category_id: "",
    subcategory: "",
    saleType: "fixed",
    price: '',
    royalties: "0",
    media: null,
    publicUrl: "",
    hash: "",
    token_id: "",
    imagePreview: null,
    auction_length: 0,
    collection_id: "",
    blockchain: "polygon",
    enableReserve: false,
    reservePrice: 0,
    putOnSale: false,
    isFreeze: false,
    timezone: "",
    docsName: "",
    supportDocDescription: "",
    discount: false,
    premium_print_cost: 0,
    printable_doc: '',
    printable_image_id: '',
    physical_print_option: '',
    physical_print_canvas_size: '',
    physical_print_unique_id_placement: '',
    edition: 'Open Edition'
  });

  const [sellItemId, setSellItemId] = useState()
  const callbackcat = (response) => {
    const { message, status } = response;
    if (status === "success") {
    }
  };
  const callback2 = (response) => {
    const { message, status } = response;
    if (status === "success") {
      let approve_art = [];
      approve_art.push(response.data);
      const dataApprove = approve_art[0].filter(
        (item) => ((item.adminStatus === "Approved") && (item.status == false))

      );
      setApprovedsearchart(dataApprove);
      setApproveArt(dataApprove);
    } else {
    }
  };
  useEffect(() => {
    if (user?._id) {
      dispatch(getArtByUserIdRequest(user?._id, callback2));
    }
  }, [user?._id]);
  const [isSupportDoc, setSupportDoc] = useState(false)

  useEffect(() => {
    if (fields?.relatedImages) {
      setSupportDoc(true)
    }
  }, [fields?.relatedImages])
  useEffect(() => {
    setDescLen(2500 - fields?.description?.length)
  }, [fields?.description]);

  const handleKeyDown = (e) => {
    // Prevent entering the minus sign (negative number)
    if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === 'E') {
      e.preventDefault();
    }
  };

  const onChangeHandler = (name) => (evt) => {
    evt.preventDefault();
    var { name, value } = evt.target;
    if (name === 'noofcopies') {
      value = value.replace(/[^0-9]/g, '');
    }
    if (name === 'premium_print_cost' || name === "price") {
      value = value.replace(/[^0-9.]/g, ''); // Remove invalid characters
      if ((value.match(/\./g) || []).length > 1) { // Ensure only one decimal point
        value = value.slice(0, value.lastIndexOf('.'));
      }
    }
    setfieldsError((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );

    setFields((prev) =>
      value !== "" || undefined || null
        ? { ...prev, [name + "Error"]: false, [name]: value }
        : { ...prev, [name + "Error"]: true, [name]: value }
    );
    if ((name === 'description') && (value.length <= maxCharacterCount)) {
      settextDis(value);
    }


  }

  const activateSell = async (wallet_owner, tokenId, id, trans, to_wallet, from_wallet) => {

    try {
      const web3intraction = new Web3Intraction(
        fields?.blockchain,
        hooks?.walletType,
        settings
      );

      if (!web3intraction.isNetworkServiceWorking()) {
        // setinternalLoading(false);
        setnftCreate(false);
        return toastr.error("Service Not Available!");
      }
      if (fields?.saleType === "auction") {
        let data = {
          name: fields?.name,
          creator: user?._id,
          hash: fields?.hash,
          price: fields?.price,
          token: tokenId,
          // auctionduration:1,
          auctionduration: (fields?.auction_length) * 86200,
          royaltyPercentage: fields?.royalties
        }
        return await web3intraction.activeAuction(
          wallAddress,
          data
        ).then((res12) => {
          if (res12.status) {
            let dataput = {
              sellType: "auction",
              nft_id: id,
              owner_id: user?._id,
              art_id: fields?.image_id,
              price: fields?.price,
              current_price: fields?.price,
              no_of_copies: fields?.noofcopies,
              status: true,
              available_copies: fields?.noofcopies,
              auction_time: ((res12?.timeStamp) + (fields?.auction_length) * 86400 + 30),
              // auction_time: Number(fields?.auction_length)*86400,
              creator_wallet: wallet_owner,
              categoty_id: fields?.category_id,
              subcategory_id: fields?.subcategory,
              collection_id: fields?.collection_id,
              loaylty: fields?.royalties,
              tokenId: tokenId,
              auction_days: fields?.auction_length,
              total_auction: ((res12?.timeStamp) * 1000 + (fields?.auction_length) * 86400 + 30000),
              // auction_date:moment(Date()).format("YYYY-MM-DDTHH:mm")
              date_end: "",
              // sahil 

            }
            dispatch(
              addSellItem(dataput, async (response) => {
                setSellItemId(response?.data?._id)
                const data_transaction = {
                  minted: fields?.noofcopies,  // { type: Number, default: 0 }
                  sellitem_id: response?.data?._id,
                  no_of_copies: fields?.noofcopies,   //{ type: Number, default: 0 }
                  trans_hash: trans,  //{ type: String, required: true }
                  from: from_wallet, //{ type: String, required: true },
                  to: to_wallet,   //{ type: String, required: true },
                  creator_address: to_wallet, //{ type: String, required: true },
                  user_id: user?._id, //{ type: mongoose.Schema.Types.ObjectId, ref: "User" },
                  nft_id: id, //{ type: mongoose.Schema.Types.ObjectId, ref: "item", required: true },
                  sale_type: "minted", //{ type: String, required: true },
                  sale_event: "Auction",
                  buyer_id: user?._id, //{ type: mongoose.Schema.Types.ObjectId, ref: "User" },
                  buyer_wallet: from_wallet, //{ type: String, required: true },
                  price: fields?.price,  //{type:Number, required:true},
                  loaylty: fields?.royalties,
                  seller_id: user?._id,

                }

                setnftCreate(false);
                return navigate('/profile/nft/created');
              }));
          } else {
            setnftCreate(false);

            toastr.error("Transaction declined");
          }
        })
      } else {
        let data = {
          name: fields?.name,
          creator: user?._id,
          hash: fields?.hash,
          price: fields?.price,
          token: tokenId,
          // auctionduration:(fields?.auction_length)*86400,
          royaltyPercentage: fields?.royalties
        }
        return await web3intraction.activeSell(
          wallAddress,
          data
        ).then((res14) => {
          if (res14.status) {
            // format Rows
            // .useState([{ sizeone: '', sizeTwo: '' }]); 

            const formatRow = (rows) => {
              var newArr = [];
              if (rows.length > 0) {

                for (let i = 0; i < rows.length; i++) {
                  let str = ""
                  if (rows && rows[i] && rows[i].sizeone && rows[i].sizeTwo) {
                    str = `${rows[i].sizeone} x ${rows[i].sizeTwo}`
                    newArr.push(str)
                  }
                }
              }
              return newArr
            }

            let dataputf = {
              sellType: "fixed",
              nft_id: id,
              owner_id: user?._id,
              art_id: fields?.image_id,
              price: fields?.price,
              current_price: fields?.price,
              no_of_copies: fields?.noofcopies,
              status: true,
              available_copies: fields?.noofcopies,
              auction_time: 2,
              categoty_id: fields?.category_id,
              subcategory_id: fields?.subcategory,
              collection_id: fields?.collection_id,
              creator_wallet: wallet_owner,
              loaylty: fields?.royalties,
              auction_days: 2,
              premium_print_cost: fields?.premium_print_cost,
              printable_image_id: fields?.printable_image_id,
              physical_print_unique_id_placement: fields?.physical_print_unique_id_placement,
              physical_print_option: fields?.physical_print_option,
              sizes: formatRow(rows)
            }
            dispatch(
              addSellItem(dataputf, async (response) => {
                const data_transaction = {
                  minted: fields?.noofcopies,  // { type: Number, default: 0 }
                  sellitem_id: response?.data?._id,
                  no_of_copies: fields?.noofcopies,   //{ type: Number, default: 0 }
                  trans_hash: trans,  //{ type: String, required: true }
                  from: from_wallet, //{ type: String, required: true },
                  to: to_wallet,   //{ type: String, required: true },
                  creator_address: to_wallet, //{ type: String, required: true },
                  user_id: user?._id, //{ type: mongoose.Schema.Types.ObjectId, ref: "User" },
                  nft_id: id, //{ type: mongoose.Schema.Types.ObjectId, ref: "item", required: true },
                  sale_type: "minted", //{ type: String, required: true },
                  sale_event: "Fixed",
                  buyer_id: user?._id, //{ type: mongoose.Schema.Types.ObjectId, ref: "User" },
                  buyer_wallet: from_wallet, //{ type: String, required: true },
                  price: fields?.price, //{type:Number, required:true},
                  loaylty: fields?.royalties,
                  seller_id: user?._id,

                }
                dispatch(addTransaction(data_transaction, (recall) => {
                  dispatch(addTransaction(data_transaction, (recall) => {
                    if (fields?.saleType === "fixed" && artWorkId !== '') {
                      const callback = (response) => {
                        if (response.status === "success") {
                          setArtWorkId(response?.data?._id)
                          toastr.success("Form submitted successfully")
                        }
                      };
                      let data = {}
                      data._id = artWorkId
                      data.nft_id = id
                      data.status = true
                      dispatch(addArtworkForm(data, callback));
                    }
                  }))
                  setnftCreate(false);
                  toastr.success("Digital Artwork has been listed successfully");
                  return navigate('/profile/nft/created');
                }))

              }));
          } else {
            setnftCreate(false);
            toastr.error("Transaction declined");
          }


        })
      }

    } catch (err) {
      toastr.error("Something went wrong");
      setnftCreate(false);
    }

  }

  const onSubmit1 = async (evt) => {
    evt.preventDefault();

    if (!window.ethereum || wallAddress === null) {
      navigate("/metamask-sign");
      return;
    }
    if (!fields?.image_id) {
      return toastr.error("Image is required");
    }

    if (!fields?.description) {
      return toastr.error("Digital Artwork description is required");

    }
    if (fields?.description.length > 2500) {
      return toastr.error("Digital Artwork description should not be greater than 2500 characters");
    }
    if (!fields?.name) {
      return toastr.error("Listing title is required");
    }
    if (!fields?.subtitle) {
      return toastr.error("Listing subtitle is required");
    }
    if (!fields?.collection_id) {
      return toastr.error("Collection is required");
    }
    if (!fields?.category_id) {
      return toastr.error("Category is required");
    }
    if (!fields?.subcategory) {
      return toastr.error("Subcategory is required");
    }
    if (!fields?.price) {
      return toastr.error("Price is required");
    }


    // if (parseInt(fields?.noofcopies) <= 0) {
    //   return toastr.error("Digital Artwork edition size should be greater than 0");
    // }

    if (fields?.saleType == "auction") {
      if (fields?.auction_length <= 0) {
        return toastr.error("Auction length is required");
      }
    } else {
      if (fields?.noofcopies < 1) {
        return toastr.error("Digital Artwork edition size should be greater than 0.");
      }
      if (!/^\d+$/.test(fields?.noofcopies)) {
        return toastr.error("Price should contain only digits");
      }

      if (!fields?.premium_print_cost) {
        return toastr.error("Premium print cost is required.")
      }
      if (!fields?.physical_print_option) {
        return toastr.error("Print option is required.")
      }
      // if (rows[0].sizeone === '' || rows[0].sizeTwo === '') {
      //   return toastr.error("Canvas width and height are required.")
      // }
      const hasEmptyField = rows.some(row => row.sizeone.trim() === '' || row.sizeTwo.trim() === '');

      if (hasEmptyField) {
        toastr.error("Size width and height are required for all entries.");
        return;
      }
    
      // Second: Check if all size combinations are unique
      const sizePairs = rows.map(row => `${row.sizeone.trim()}x${row.sizeTwo.trim()}`);
      const uniqueSizePairs = new Set(sizePairs);
    
      if (sizePairs.length !== uniqueSizePairs.size) {
        toastr.error("Each size (width x height) must be unique.");
        return;
      }
    }



    try {
      if (settings && fields?.blockchain) {
        // setinternalLoading(true);
        let data1 = {
          ...fields, media: fields?.image_id, token_id: "0", user_id: user?._id
        };
        const web3intraction = new Web3Intraction(
          fields?.blockchain,
          hooks?.walletType,
          settings
        );
        if (!web3intraction.isNetworkServiceWorking()) {
          // setinternalLoading(false);
          return toastr.error("Service Not Available!");
        }
        web3intraction
          .ismatic()
          .then(async (res) => {
            if (!res) {
              setMaticmainnet(true);
              return ''
            }
            setMaticmainnet(false);
            dispatch(
              postItem(data1, async (response) => {
                if (response?.status === "failure") {
                  return toastr.error("Artwork name already exists")
                } else {
                  let id = response.data._id;

                  let data = {
                    name: fields?.name,
                    creator: user?._id,
                    category: fields?.category_id,
                    amount: fields?.noofcopies,
                    copies: fields?.noofcopies,
                    hash: fields?.hash,
                    price: fields?.price,
                    auctionduration: (fields?.auction_length) * 86400,
                    royaltyPercentage: Number(fields?.royalties)
                  }
                  setnftCreate(true);
                  return await web3intraction.newMintNFT(
                    wallAddress,
                    data
                  ).then((res) => {
                    if (res.status) {
                      let trans = res.trans_Hash;
                      let token_idt = res.tokenId;
                      let to_wallet = res.to;
                      let from_wallet = res.from;
                      const dataput = { itemId: id, token_id: res.tokenId, token_hash: res.trans_Hash }
                      dispatch(
                        putItem(dataput, async (response) => {
                          // setnftCreate(false);
                          if (response?.status == "failure") {
                            return toastr.error("something going wrong")
                          } else {
                            // getCollectionData();
                            const data_owner = {
                              nft_id: id,
                              owner_id: user?._id,
                              total_copies: fields?.noofcopies,
                              price: fields?.price,
                              available_copies: fields?.noofcopies,
                              creator: user?._id,
                              buy_from: wallAddress,
                              status: true,
                              owner_wallet: from_wallet,
                              loyality: fields?.royalties,
                              onSale: true,
                              ownership_status: "Completed",
                              owner_type: false
                            }
                            dispatch(addParticularOwner(data_owner))
                            toastr.success("Artwork has been minted successfully");
                            return activateSell(from_wallet, token_idt, id, trans, to_wallet, from_wallet);
                          }
                        }));
                    } else {
                      toastr.error("Transaction declined");
                      setnftCreate(false);
                    }
                  }).catch((err) => {
                    setnftCreate(false);
                    return toastr.error("Transaction declined")
                  })
                }
              })

            );
          })

      } else {
        setnftCreate(false);
        return toastr.error("Something went wrong")
      }

    } catch (err) {
      setnftCreate(false);
      return toastr.error(err)
    }
  };


  useEffect(() => {
    dispatch(getSubCategories());
  }, []);

  useEffect(() => {
    if (user?._id) {
      setcollectionfilter((prevState) => ({
        ...prevState,
        author: user?._id,
      }));
    }
  }, [user?._id]);


  useEffect(() => {
    dispatch(
      getCategories(
        { limit: 100, orderBy: "", order: "", page: 1 },
        callbackcat
      )
    );
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const calPrice = async () => {
        let amount = fields?.price;
        let symbol =
          fields?.blockchain === "polygon" ? "MATIC" : item?.blockchain;
        let data = await converCryptoToDollar(amount, symbol);
        setUsdPrice((pre) => ({
          ...pre,
          data,
        }));
      };
      calPrice({ price: fields?.price });
    }, 300);
    return () => clearTimeout(delayDebounceFn);
  }, [fields?.price]);

  useEffect(() => {
    //console.log("email", email);
    const callback = (response) => {
      // console.log("reponse", response);
      if (response.status === "success") {
        setCollectionsList(response.data);
      } else {
      }
    };
    let data = {};
    data.email = email;
    //  console.log("emao", data);
    dispatch(getNewCollectionByEmailStart(data, callback));
  }, [email]);

  // useEffect(() => {
  //   calPrice();
  // }, [item]);

  const typeofsale = (event) => {
    // console.log(event.target.value);
    const value = event.target.value;
    if (value === "fixed") {
      setsaletype("fixed");
      setFields((prev) => ({ ...prev, saleType: "fixed", typeofsale: "fixed", price: 0 }));
    } else {

      setsaletype("auction");
      setFields((prev) => ({
        ...prev,
        noofcopies: 1,
        saleType: "auction",
        typeofsale: "auction",
        price: 0,
      }));
    }
    // this.setState({
    //   selectedOption: event.target.value
    // });
  };
  const [upArt, setAploadArt] = useState(false);
  const [nftCreate, setnftCreate] = useState(false);
  const [approvedsearchart, setApprovedsearchart] = useState([]);
  const [showart, setShowart] = useState();
  const [previewart, setPreviewart] = useState();
  const [printableImage, setPrintableImage] = useState()
  const selectApproveArt = () => {
    setAploadArt(true);
  };

  const closedialogBox = () => {
    setAploadArt(false);
    setSearch('')
  };
  const showselectart = (item) => {

    setShowart(item);
  };

  const uploadImgae = () => {
    if (showart !== undefined) {
      // console.log(showart,"asdhd arts")
      console.log("showart", showart)
      setPreviewart(showart);
      setAploadArt(false);
      setFields((prev) => ({
        ...prev,
        image_id: showart._id,
        image_url: showart.image,
        hash: showart.hash,
        publicUrl: showart.publicUrl,
      }));
    } else {
      return toastr.error("Please select an art")
    }
    //else{
    // }
  };

  const uploadDocsSuccess = (name) => (response) => {
    const { _id, link, message, file_name } = response.data;
    setFields((prev) => ({ ...prev, relatedImages: _id, docsName: file_name }));

    toastr.success("Additional support document has been uploaded successfully.");
    // onChangeHandler(name)({ target: { value: _id } });
    if (name == "media") setFields((prev) => ({ ...prev, docsType: link }));
  };
  const handleDocsChange = (name) => (evt) => {
    if (!evt) {
      return;
    }
    const docs = evt.target.files;
    if (docs.length == 0) {
      return "";
    }
    var ext = docs[0].name.split(".").pop().toLowerCase();
    if (name === "printableImage" && (ext !== "tiff" && ext !== "jpeg" && ext !== "tif")) {

      return toastr.error("Only JPEG, TIFF, and TIF extensions are allowed")
    }
    else if (name === "supportdoc" &&
      (
        ext !== "png" &&
        ext !== "jpg" &&
        ext !== "jpeg" &&
        ext !== "pdf" &&
        ext !== "mp3" &&
        ext !== "mp4")
    ) {
      return toastr.error("Only png, jpg, pdf extensions allowed");
    }
    if ((name === "printableImage") && (ext === "tiff" || ext === "jpeg" || ext === "tif")) {
      const file = evt.target.files[0];
      let firstname = evt.target.files[0].name.replace(/\s/g, "")
      let removed_tiff = firstname.split(".")[0]
      let name = removed_tiff
      setFields((prevState) => ({
        ...prevState,
        printable_doc: name
      }));
      const uploadPrintableImageSuccess = (name) => (response) => {
        const { _id, link, message, file_name } = response.data;
        setFields((prev) => ({ ...prev, printable_image_id: _id }));

        toastr.success("Printable document has been uploaded successfully.");
        if (name == "media") setFields((prev) => ({ ...prev, docsType: link }));
      };
      dispatch(uploadFile({ image: file }, uploadPrintableImageSuccess("media")));
    } else {
      if (docs && docs[0]) {
        dispatch(uploadFile({ image: docs[0] }, uploadDocsSuccess("media")));
        setFields((prevState) => ({
          ...prevState,
          docs_upload: docs[0].name,
          relatedImages: docs[0],
        }));
      }
    }
  };
  const [subCategoryList, setSubCategoryList] = useState();
  const categoryHandler = (e) => {
    const category = e.target.value;
    const data = subCategory.filter((item) => item?.category?._id === category);
    setSubCategoryList(data);
    setFields((prevState) => ({ ...prevState, category_id: category }));
  };
  const { subCategory } = useSelector((state) => state?.categories);
  const { categories } = useSelector((state) => state?.categories);

  const createNFTProcessing = () => {
    setnftCreate(true);
  };
  const [activeforsell, setactiveforsell] = useState(false);
  const [nftMinted, setnftMinted] = useState(false);
  useEffect(() => {
    if (search !== '') {
      setApprovedsearchart(approveArt?.filter((item) => { return search === '' ? item : (item.artInfo.title ? (item.artInfo.title?.split(".")[0].toLowerCase().includes(search.toLowerCase())) : item?.image?.file_name?.split(".")[0].toLowerCase().includes(search.toLowerCase())) }))

    } else {
      setApprovedsearchart(approveArt)
    }
  }, [search])

  useEffect(() => {
    document.querySelectorAll('textarea').forEach((el) => {
      el.style.height = el.setAttribute('style', 'height: ' + el.scrollHeight + 'px');
      el.classList.add('auto');
      el.addEventListener('input', e => {
        el.style.height = 'auto';
        el.style.height = (el.scrollHeight) + 'px';
      })
    })
  }, [])
  const reUpload = () => {
    setFields((prevState) => ({
      ...prevState,
      docs_upload: '',
      relatedImages: '',
    }));
    setSupportDoc(false);
  }
  const reUploadPrintable = () => {
    setFields((prevState) => ({
      ...prevState,
      printable_doc: ''
    }));
  }


  const reArtUpload = () => {
    setPreviewart('')
    setShowart('')
  }


  const func = () => {
    const moment = require('moment');
    const unixTimestamp = moment().unix();
    const timestamp = moment.unix(unixTimestamp);
    const daysToAdd = 5;
    const updatedTimestamp = timestamp.add(daysToAdd, 'days');
  }
   useEffect(()=>{console.log("fuelds", fields)}, [fields])
  useEffect(() => {
    func()
  }, [])


  const handlePhysicalPrintChange = (name, value, e) => {
    e.preventDefault()
    // if (name === "print_dimensions") {
    //     const dimensionRegex = /^\d+\s*x\s*\d+\s*\w*$/;
    //     if (!fields.print_dimensions.trim()) {
    //         toastr.error("Enter valid dimensions in the format 'Width x Height'.");
    //     } else if (!dimensionRegex.test(fields.print_dimensions)) {
    //         toastr.error("Enter valid dimensions in the format 'Width x Height'.");
    //     }
    // }
    setFields((p) => ({ ...p, [name]: value }))
  }
  return (
    <>


      {(loading || fileLoading) &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <Modal id="approved-artwork"
        className="EmailVerifyBoxModel uploadimg selectArt text-center"
        show={upArt}
        centered
        animation={false}
      >
        <div className="dialogHeader px-4 pt-4">
          <div className="text-start">
            <h3 className="mb-1">Approved Artwork</h3>
            <p>Select any one approved artwork to create digital artwork </p>
          </div>
          <button onClick={closedialogBox} className="margin-button">
            <i className="fa-regular fa-xmark"></i>
          </button>
        </div>
        {/* <div className="overflowUploadbOx px-4"> */}
        <div className="px-4 py-3">
          {/* {approveArt.length > 0 &&
            <Row className=" searchBoxdialog">
              <Input placeholder="Search" onChange={(e) => setSearch(e.target.value)} type="text" style={{position:'relative'}} className="searchInput form-control" />
              
            <i className="fa-regular fa-xmark" style={{position:"absolute", right:"23rem", top:"11rem"}}></i>

            </Row>
          } */}
          {approveArt.length > 0 && (
            <Row className="searchBoxdialog" id="searchBoxdialog">
              <div className="col-md-3 ">
                <div className="position-relative">
                  <Input

                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    type="text"
                    className="searchInput form-control w-100"
                  />
                  {search && (
                    <button onClick={() => setSearch('')} className="searchcanslbtn">
                      <i
                        className="fa-regular fa-xmark"

                      // Clear the search state
                      />
                    </button>

                  )}
                </div>

              </div>
            </Row>
          )}


        </div>
        <div className="overflowUploadbOx px-4">


          <div className="upoadedImage">
            <div className="uploadedArt selectart">
              <div className="row">
                {approvedsearchart.length > 0 ? (
                  <>
                    {approvedsearchart.map((item, index) => (
                      <Col
                        key={index}
                        className="mb-3"
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                      >
                        <div className="image " onClick={() => showselectart(item)}>
                          {/* <div className="artbox"> */}
                          <Label style={{ border: "1px solid var(--gray3)", borderRadius: "0.5rem", height: "150px !important" }} className={showart?.images?._id === item?.images?._id ? 'active' : ''} htmlFor="image1">
                            <figur>
                              <img src={item?.images?.link} alt="Art" className="img-class" />
                              <figcaption className="p-1" >
                                {item?.artInfo
                                  ? item.artInfo.title.length > 21
                                    ? item.artInfo.title.substring(0, 21) + "..."
                                    : item.artInfo.title
                                  : item?.images?.file_name.split(".")[0].length > 21
                                    ? item.images.file_name.split(".")[0].substring(0, 21) + "..."
                                    : item.images.file_name.split(".")[0]}
                              </figcaption>
                            </figur>
                          </Label>
                        </div>
                      </Col>
                    ))}
                  </>
                ) : (
                  <>
                    <div className="text-center py-4">
                      <h3>No Arts Available</h3>
                    </div>
                  </>
                )}

              </div>


            </div>
          </div>
        </div>
        {approvedsearchart.length > 0 &&

          <div className="text-center px-3 pb-3">
            {/* <button type="button" className="btn btn-outline-primary px-5" onClick={closedialogBox}>Cancel</button> */}

            <button className="btn btn-primary px-5 " id="submit-btns" onClick={uploadImgae}>
              Submit
            </button>
          </div>
        }

        {/* <button className="btn btn-primary btn-sm py-2" onClick={closedialogBox}>Close</button> */}
      </Modal>
      <Modal
        className="EmailVerifyBoxModel uploadimg selectArt text-center"
        show={nftCreate}
        centered
        animation={false}
      >
        <div className="nftLoading">
          <div className="loaderNFT">
            <i className="fa-thin fa-loader"></i>
          </div>
          <h3>
            Your unique Digital Artwork is being minted on the blockchain, securing its
            place in the digital universe.
          </h3>
        </div>
      </Modal>
      <Modal
        className="EmailVerifyBoxModel uploadimg selectArt text-center"
        show={nftMinted}
        centered
        animation={false}
      >
        <div className="nftLoading">
          <div>
            <img src="/images/successImageNFT.svg" width={200} alt="" />
          </div>
          <h4>Congratulations! </h4>
          <h3 className="mt-2">You've successfully minted your unique Digital Artwork!</h3>
        </div>
      </Modal>
      <Modal
        className="AuthenticityBoxModel uploadimg selectArt text-center"
        show={showAuthenticity}
        centered
        animation={false}
      >

        <CertificateofAuthenticity dialogOpan={Authenticity} previewart={previewart?.artInfo?.title || previewart?.images?.file_name} isPhysicalArt={isChecked} setArtWorkId={setArtWorkId} />
      </Modal>

      <Row>
        <Col lg={12} className="mb-1">
          <h1><i onClick={menuopen} className="fa-light fa-bars-sort"></i>  </h1>
        </Col>
        <Col lg={12}>
          {!resellId && !itemId ? (
            <Form >
              <Row>
                <Col lg={12}>
                  <div
                    className={
                      "createCollection  uploadFilecrete mb-1" +
                      (fieldsError?.imageError ? " invalid" : "")
                    }
                  >
                    <div className={`upload-btn-wrapper`}>
                      <div className="text-center uploadimgnew">
                        {previewart?.image?.link ? (
                          <>
                            <div className="position-relative">
                              <img
                                src={previewart?.images?.link || ""}
                                alt=""
                                className="img-fluid"
                              />
                              <button type="button" onClick={reArtUpload} className="upoadDocClose closebtnart">
                                <i class="fa-solid fa-circle-xmark"></i>
                              </button>
                            </div>
                          </>
                        ) : (<>
                          <Label
                            onClick={selectApproveArt}
                            className="d-grid cursor-pointer"
                          >

                            Select Approved Art
                          </Label>
                        </>)}

                      </div>
                    </div>
                    <p className="mb-3 text-center uploadimgText">
                      Select your mesmerizing digital artwork for exclusive Digital Artwork creation, a unique addition to your personal collection.
                    </p>
                  </div>
                  <div className="createCollection">
                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Printable Format</Label>
                      {fields?.printable_doc ? (
                        <div className="uploaddocs position-relative">

                          <Label className="position-relative" for="printableDocs">
                            <button type="button" onClick={reUploadPrintable} className="upoadDocClose">
                              <i class="fa-solid fa-circle-xmark"></i>
                            </button>
                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp;{fields?.printable_doc}
                          </Label>
                        </div>
                      ) : (
                        <div className="uploaddocs">
                          <Input
                            className="d-none"
                            type="file"
                            name="printableImage"
                            id="printableDocs"
                            // invalid={docs_linkError}
                            // required={docs_linkError}
                            onChange={handleDocsChange("printableImage")}
                          // accept="image/*"
                          />
                          <Label for="printableDocs">

                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp; UPLOAD FROM YOUR DEVICE

                          </Label>
                          <p className="pdecription mb-1 d-flex gap-2 align-items-center">
                            {/* <span className="priorityicon">!</span> */}
                            <i class="fa-regular fa-circle-exclamation"></i> <span>Upload high quality image for printing Jpeg/tiff format</span>
                          </p>
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Support Document</Label>
                      {fields?.docs_upload ? (
                        <div className="uploaddocs position-relative">

                          <Label className="position-relative" for="supportDocs">
                            <button type="button" onClick={reUpload} className="upoadDocClose">
                              <i class="fa-solid fa-circle-xmark"></i>
                            </button>
                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp;{fields?.docs_upload}

                          </Label>
                        </div>
                      ) : (
                        <div className="uploaddocs">
                          <Input
                            className="d-none"
                            type="file"
                            name="supportdoc"
                            id="supportDocs"
                            // invalid={docs_linkError}
                            // required={docs_linkError}
                            onChange={handleDocsChange("supportdoc")}
                          // accept="image/*"
                          />
                          <Label for="supportDocs">

                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp; UPLOAD FROM YOUR DEVICE

                          </Label>
                        </div>
                      )}

                    </FormGroup>
                    {isSupportDoc &&
                      <FormGroup className="form-group mb-4">
                        <Label className="mb-1">Support Document Description</Label>
                        <div className="position-relative">
                          <Input
                            type="textarea"
                            name="supportDocDescription"
                            placeholder="Enter text here"
                            value={fields?.supportDocDescription}
                            cols={"7"}
                            maxLength={1000}
                            onChange={onChangeHandler("supportDocDescription")}
                            className={
                              "form-control bg-white" +
                              (fieldsError?.supportDocDescriptionError && "invalid"
                                ? " gender"
                                : "")
                            }
                          // required={fieldsError?.supportDocDescriptionError}
                          />
                          <div className="addresmsg position-absolute bottom-0 end-0">
                            {1000 - fields?.supportDocDescription?.length + "/1000"}
                          </div>
                        </div>

                      </FormGroup>}

                    {/* <div className="addresmsg position-absolute bottom-0 end-0">{descLen + "/300"}</div> */}
                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Digital Artwork Description</Label>
                      <div className="position-relative">
                        <Input
                          type="textarea"
                          name="description"
                          maxLength={2500}
                          placeholder="Enter text here"
                          value={fields?.description}
                          cols={"7"}
                          onChange={onChangeHandler("description")}
                          className={
                            "form-control bg-white" +
                            (fieldsError?.descriptionError && "invalid"
                              ? " gender"
                              : "")
                          }
                          required={fieldsError?.descriptionError}
                        // placeholder="Define your NFT"
                        />
                        <div className="addresmsg position-absolute bottom-0 end-0">
                          {descLen + "/2500"}
                        </div>
                      </div>
                      {/* <div className="addresmsg position-absolute bottom-0 end-0">{descLen + "/2500"}</div> */}
                      <p className="pdecription mt-2">
                        This description will include a link to this URL on this Collection detail page.
                      </p>

                    </FormGroup>
                    <FormGroup className="form-group mb-4">
                      <Label className="mb-2 listingtext">
                        Listing Details
                      </Label>
                      <FormGroup className="form-group mb-4">
                        <Label className="mb-1 lableSmall">Listing Title</Label>
                        <Input
                          name="name"
                          value={fields?.name}
                          onChange={onChangeHandler("name")}
                          placeholder="Enter text here"
                          className={
                            "form-control bg-white" +
                            (fieldsError?.descriptionError && "invalid"
                              ? " gender"
                              : "")
                          }
                          required={fieldsError?.nameError}
                        // placeholder="Item Name"
                        />
                      </FormGroup>
                      <FormGroup className="form-group mb-4">
                        <Label className="mb-1 lableSmall">
                          Listing Subtitle
                        </Label>
                        <Input
                          name="subtitle"
                          placeholder="Enter text here"
                          value={fields?.subtitle}
                          onChange={onChangeHandler("subtitle")}
                          className={
                            "form-control bg-white" +
                            (fieldsError?.descriptionError && "invalid"
                              ? " gender"
                              : "")
                          }
                          required={fieldsError?.subtitleError}
                        // placeholder="Item Name"
                        />
                      </FormGroup>
                    </FormGroup>
                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1 lableSmall">Collections</Label>
                      <Input
                        // disabled={id ? true : false}
                        type="select"
                        name="collection_id"
                        value={fields?.collection_id}
                        onChange={onChangeHandler("collection_id")}
                        className={"form-control bg-white"}
                        required={fieldsError?.collection_idError}
                      >
                        <option key="01" value="">
                          Select Collection
                        </option>
                        {collectionsList?.map((item, idx) => (
                          <option key={item?._id} value={item?._id}>
                            {item?.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Select Category</Label>
                      <Input
                        type="select"
                        value={fields?.category_id}
                        className={"form-control bg-white"}
                        onChange={categoryHandler}
                      >
                        <option>Select Category</option>
                        {categories &&
                          categories.map((item) => (
                            <option value={item._id}>{item.name}</option>
                          ))}
                      </Input>
                    </FormGroup>
                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Select Subcategory</Label>
                      <Input
                        type="select"
                        className={"form-control bg-white"}
                        name="subcategory"
                        value={fields?.subcategory}
                        onChange={onChangeHandler("subcategory")}
                        required
                      >
                        <option selected>
                          Select Subcategory
                        </option>
                        {subCategoryList &&
                          subCategoryList.map((item1) => (
                            <option key={item1?._id} value={item1?._id}>
                              {item1.name}
                            </option>
                          ))}
                      </Input>
                    </FormGroup>
                    <Row>
                      <Col lg={12} className="mb-3">
                        <FormGroup className="form-group mb-4">
                          <div className="d-flex justify-content-between">
                            <Label>Type of Sale</Label>
                            {/* <div className="customeradio">
                              <input

                                id="myCheckbox"
                                type="checkbox" />
                              <Label for="myCheckbox"></Label>
                              <p>Limited</p>
                            </div> */}
                          </div>

                          <div className="typeofsale fixe">
                            <Input
                              type="radio"
                              onChange={typeofsale}
                              checked={saletype === "fixed"}
                              name="typeofsale"
                              value={"fixed"}
                              id="fixed"
                            />
                            <Label className=" active" htmlFor="fixed">
                              Fixed
                            </Label>
                            {!resale && (
                              <>
                                <Input
                                  type="radio"
                                  onChange={typeofsale}
                                  name="typeofsale"
                                  value={"auction"}
                                  id="Auction"
                                />
                                <Label className=" active" htmlFor="Auction">
                                  Auction
                                </Label>
                              </>
                            )}
                          </div>


                        </FormGroup>
                      </Col>
                      <p className="note-txt"><b>Note:</b> For guidance on pricing your Digital Artworks, <a href="/images/nft_pricing_guide_lines.pdf" target="_blank" className="text-primary fw-semibold">check here</a>.</p>
                      {saletype === "fixed" ? (
                        <>

                          <Col lg={12} className="mb-3">
                            <div className="bypricenow">
                              <Row>
                                <Col lg={4}>
                                  <FormGroup className="form-group mb-4">
                                    <Label>Buy Now Price</Label>
                                    <div className="position-relative mb-2">
                                      <Input
                                        type="number"
                                        name="price"
                                        value={fields?.price}
                                        onChange={onChangeHandler("price")}
                                        className="ps-5"
                                      />
                                      <img
                                        src="../../../../images/svg/polygonIcon.svg"
                                        width={30}
                                        className="position-absolute top-0 bottom-0 start-0 ms-2 my-auto"
                                        alt="sth"
                                      />
                                    </div>
                                    <p className="mb-2">${usdPrice?.data}</p>

                                    {/* <Label>Premium Print Cost (Optional)  </Label>

                                    <div className="position-relative mb-2">
                                      <Input
                                        type="number"
                                        name="premium_print_cost"
                                        value={fields?.premium_print_cost}
                                        onChange={onChangeHandler("premium_print_cost")}
                                      />
                                      <img
                                        src="../../../../images/svg/polygonIcon.svg"
                                        width={30}
                                        className="position-absolute top-0 bottom-0 start-0 ms-2 my-auto"
                                        alt="sth"
                                      />

                                    </div> */}
                                  </FormGroup>
                                </Col>
                                <Col lg={4}>
                                  <FormGroup className="form-group">
                                    <Label>Digital Artwork Edition Size</Label>
                                    <div className="position-relative mb-2">
                                      <Input
                                        type="number"
                                        name="noofcopies"
                                        value={fields?.noofcopies}
                                        onChange={onChangeHandler("noofcopies")}
                                        onKeyDown={handleKeyDown}
                                      />
                                    </div>{" "}
                                    <p>
                                      $
                                      {fields?.noofcopies &&
                                        (usdPrice?.data * Number(fields?.noofcopies)).toFixed(4)} {" "}
                                    </p>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </>
                      ) : (
                        <Col lg={12} className="mb-3">

                          <div className="bypricenow">
                            <Row>
                              <Col lg={4}>
                                <FormGroup className="form-group">
                                  <Label>Starting Bid Price</Label>
                                  <div className="position-relative mb-0">
                                    <Input
                                      type="text"
                                      name="price"
                                      value={fields?.price}
                                      onChange={onChangeHandler("price")}
                                      className="ps-5"
                                    />
                                    <img
                                      src="../../../../images/svg/polygonIcon.svg"
                                      width={30}
                                      className="position-absolute top-0 bottom-0 start-0 ms-2 my-auto"
                                      alt="sth"
                                    />
                                  </div>
                                  <p className="mb-0">${usdPrice?.data}</p>
                                </FormGroup>
                              </Col>
                              <Col lg={4}>
                                <FormGroup className="form-group">
                                  <Label>Auction Length</Label>
                                  <div className="position-relative mb-0">
                                    <Input
                                      type="select"
                                      name="auction_length"
                                      value={fields?.auction_length}
                                      onChange={onChangeHandler(
                                        "auction_length"
                                      )}
                                      className={"form-control "}
                                      required
                                    >
                                      <option key={15} selected>
                                        Select Auction Length
                                      </option>
                                      <option key={1} value={1}>
                                        {" "}
                                        1 day
                                      </option>
                                      <option key={2} value={2}>
                                        {" "}
                                        2 days
                                      </option>
                                      <option key={3} value={3}>
                                        {" "}
                                        3 days
                                      </option>
                                      <option key={4} value={4}>
                                        {" "}
                                        4 days
                                      </option>
                                      <option key={5} value={5}>
                                        {" "}
                                        5 days
                                      </option>
                                      <option key={6} value={6}>
                                        {" "}
                                        6 days
                                      </option>
                                      <option key={7} value={7}>
                                        {" "}
                                        7 days
                                      </option>
                                      <option key={8} value={8}>
                                        {" "}
                                        8 days
                                      </option>
                                      <option key={9} value={9}>
                                        {" "}
                                        9 days
                                      </option>
                                      <option key={10} value={10}>
                                        {" "}
                                        10 days
                                      </option>
                                      <option key={11} value={11}>
                                        {" "}
                                        11 days
                                      </option>
                                      <option key={12} value={12}>
                                        {" "}
                                        12 days
                                      </option>
                                      <option key={13} value={13}>
                                        {" "}
                                        13 days
                                      </option>
                                      <option key={14} value={14}>
                                        {" "}
                                        14 days
                                      </option>
                                    </Input>
                                    {/* <img src="../../../../images/svg/polygonIcon.svg" width={30} className="position-absolute top-0 bottom-0 start-0 ms-2 my-auto" alt="sth" />
                                     */}{" "}
                                  </div>
                                  {/* <p className="mb-0">$0</p> */}
                                </FormGroup>
                              </Col>

                            </Row>

                            <Row>
                            </Row>
                          </div>
                        </Col>
                      )}
                      {fields?.saleType === "fixed" &&
                        <Col lg={12} className="mb-3">
                          {fields?.saleType === "fixed" &&
                            <div className="mb-3">
                              {/* Button to trigger the modal */}
                              {/* <div className="CustomeCheckBox">
                              <Input id="PhysicalPrint" checked={isChecked}
                                onChange={handleCheckboxChange} type="checkbox" />
                              <label htmlFor="PhysicalPrint"  ></label>
                              <div><span className=" text-black certificate-text">Physical Print</span></div>
                            </div> */}

                              <div className="CustomeCheckBox customeRadioNew">
                                <Input
                                  id="OpenEdition"
                                  checked={fields?.edition === 'Open Edition'}
                                  onChange={() => handleEditionChange('Open Edition')}
                                  type="checkbox"
                                />
                                <label htmlFor="OpenEdition"></label>
                                <div>
                                  <span className="text-black certificate-text">Open Edition</span>
                                </div>

                                <Input
                                  id="LimitedEdition"
                                  checked={fields.edition === 'Limited Edition'}
                                  onChange={() => handleEditionChange('Limited Edition')}
                                  type="checkbox"
                                />
                                <label htmlFor="LimitedEdition"></label>
                                <div>
                                  <span className="text-black certificate-text">Limited Edition</span>
                                </div>
                              </div>









                            </div>
                          }
                          {/* <FormGroup className="form-group">
                          <div className="custumradio">
                            <input
                              id="myCheck-box"
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange} />
                            <Label for="myCheck-box"></Label>
                            <h5>Physical Print</h5>
                          </div>
                        </FormGroup> */}


                          <div className="bypricenow">
                            <Row>
                              {/* <Col lg={12}> */}
                              <FormGroup className="form-group">

                                <div className="canvas-price">
                                  <div>
                                    <Label>Premium Print Cost</Label>

                                    {/* <div className="position-relative mb-0">
                                      <Input
                                        type="text"
                                        name="price"
                                        value={fields?.price}
                                        onChange={onChangeHandler("price")}
                                        className="ps-5"
                                      />
                                      <img
                                        src="../../../../images/svg/polygonIcon.svg"
                                        width={30}
                                        className="position-absolute top-0 bottom-0 start-0 ms-2 my-auto"
                                        alt="sth"
                                      />
                                      
                                    </div> */}
                                    {/* type="number"
                                        name="premium_print_cost"
                                        value={fields?.premium_print_cost}
                                        onChange={onChangeHandler("premium_print_cost")} */}
                                    <div className="position-relative mb-2">
                                      <Input
                                        type="number"
                                        name="premium_print_cost"
                                        value={fields?.premium_print_cost} className="ps-5"
                                        onChange={onChangeHandler("premium_print_cost")}
                                      />
                                      <img
                                        src="../../../../images/svg/polygonIcon.svg"
                                        width={30}
                                        className="position-absolute top-0 bottom-0 start-0 ms-2 my-auto"
                                        alt="sth"
                                      />

                                    </div>
                                  </div>

                                  <div className="">
                                    <Label>Print Option</Label>
                                    <div className="printStyle p-0 mt-0">

                                      <div className="d-flex gap-3">
                                        <button className={`printcommon-btn ${fields?.physical_print_option === 'Canvas' ? 'active' : ''}`} onClick={(e) => handlePhysicalPrintChange('physical_print_option', 'Canvas', e)}> Canvas</button>
                                        <button className={`printcommon-btn ${fields?.physical_print_option === 'Paper' ? 'active' : ''}`} onClick={(e) => handlePhysicalPrintChange('physical_print_option', 'Paper', e)}> Paper</button>
                                        <button className={`printcommon-btn ${fields?.physical_print_option === 'Both' ? 'active' : ''}`} onClick={(e) => handlePhysicalPrintChange('physical_print_option', 'Both', e)}> Both</button>
                                      </div>
                                    </div>
                                    {/* <div className="canvas-btn">
                                      <button>Canvas</button>
                                      <button>Paper</button>
                                      <button>Both</button>
                                    </div> */}

                                  </div>

                                </div>

                                <form>


                                  <div className="mt-3"><Label className="mb-2">Size
                                  </Label>
                                    <button className="add-dlt-btn" onClick={handleAddRow}>
                                      <img src="/images/svg/addicon.svg" className="img-width" alt="" />
                                    </button>
                                  </div>
                                  {rows.map((row, index) => (<div className="row">
                                    <div key={index}>
                                      <div className="d-flex">

                                        <div className="d-flex align-items-end gap-2" key={index}>
                                          <input
                                            className="form-control"
                                            type="text"
                                            name="sizeone"
                                            placeholder="Height"
                                            value={row.sizeone}
                                            onChange={(e) => handleInputChange(e, index)}

                                            required
                                          />
                                          {/* <span style={{paddingBottom:'3px'}}>/cms</span> */}
                                        </div>
                                        <h5 className="my-auto p-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16" stroke="black" stroke-width="2" stroke-linecap="round"/>
</svg>
</h5>
                                        <div className="d-flex align-items-end gap-2">
                                          <input
                                            className="form-control"
                                            type="text"
                                            name="sizetwo"
                                            placeholder="Width"
                                            value={row.sizeTwo}
                                            onChange={(e) => handleInputChange(e, index)}

                                          />
                                          <span style={{paddingBottom:'3px'}}>/cms</span>
                                        </div>
                                        {rows.length > 1 &&
                                          <button className="add-dlt-btn" onClick={() => handleRemoveRow(index)}>
                                            <img src="/images/svg/delete.svg" className="img-width" alt="" />
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  </div>))}
                                </form>

                              </FormGroup>
                              {/* </Col> */}

                            </Row>

                            <Row>
                              {/* <Col lg={12} className="mb-3">                        
                              <FormGroup className="form-group">
                                 */}
                              <Label className="head-nft">DIGITAL ARTWORK UNIQUE ID PLACEMENT
                              </Label>

                              <div className="canvas-price">

                                <div className="">
                                  {/* <Label>Print Option</Label> */}

                                  <div className="canvas-btn">
                                    {/* <button>Below Canvas</button>
                                    <button>Upper</button> */}
                                    <button onClick={(e) => handlePhysicalPrintChange('physical_print_unique_id_placement', e.target.value, e)} value={"Lower Right Side"} className={`printcommon-btn ${fields?.physical_print_unique_id_placement === 'Lower Right Side' ? 'active' : ''}`}>Lower Right Side</button>
                                    <button onClick={(e) => handlePhysicalPrintChange('physical_print_unique_id_placement', e.target.value, e)} value={"Lower Left Side"} className={`printcommon-btn ${fields?.physical_print_unique_id_placement === 'Lower Left Side' ? 'active' : ''}`}>Lower Left Side</button>
                                  </div>

                                </div>

                              </div>
                              {/* <div className="position-relative mb-0">
                                      <Input
                                        type="text"
                                        name="price"
                                        value=""
                                        onChange=""
                                        className="width-nft"
                                        
                                      />
                                      
                                    </div> */}

                              {/* </FormGroup> */}


                              {/* </Col> */}
                            </Row>
                          </div>

                        </Col>
                      }


                      <Col lg={7}>
                        <FormGroup className="form-group mb-4">
                          <Label className="mb-2">Royalties</Label>
                          <input
                            type="range"
                            name="royalties"
                            min="0"
                            max="20"
                            value={fields?.royalties}
                            onChange={onChangeHandler("royalties")}
                            className="rangeSlider"
                          />
                          <div className="d-flex align-items-center justify-content-between rangeText">
                            <p>{fields?.royalties}%</p>
                            <p>20%</p>
                          </div>
                        </FormGroup>
                      </Col>
                      <Col lg={4} className={"my-auto"}>
                        <p className="fw-semibold">
                          This is the percentage you would receive on a resale of your image.
                        </p>
                      </Col>
                      <Col lg={4} className={"my-auto"} hidden>
                        <FormGroup className="form-group mb-4">
                          <Row>
                            <Col lg={4}>
                              <Input
                                type="select"
                                className={"form-control bg-white form-select"}
                              >
                                <option>Status</option>
                                <option>Live Now</option>
                                <option>Schedule</option>
                              </Input>
                            </Col>
                          </Row>
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <div className="bypricenow mt-4">
                        <h4 className="fw-bold">Platform Fee</h4>
                        <p>
                          Please note that a platform fee of 20% is applied to
                          the total sale amount of each Artworks.
                        </p>
                        <p className="mb-1">
                          <b>Fixed-Price Listings:</b> Set your price, 2-year
                          listing.
                        </p>
                        <p className="mb-0">
                          <b>Auction Listings:</b> Start bid, max 2-week
                          duration.
                        </p>
                      </div>
                    </FormGroup>

                    <div>
                      {/* Button to trigger the modal */}
                      <p className="linktext authtext"><span onClick={Authenticity}>Certificate of Authenticity</span></p>

                      {/* <div className="CustomeCheckBox">
                        <Input id="art" type="checkbox" />
                        <label htmlFor="art"></label>
                        <div><span className=" text-black certificate-text">Certificate of Authenticity</span></div>
                      </div> */}
                    </div>
                    <FormGroup>
                      <div className="text-center Done-wrap">

                        {activeforsell === true ? (
                          <button
                            type="submit"
                            className="btn btn-primary px-5"
                            onClick={createNFTProcessing}
                          >
                            Activate for Sale
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-secondary text-white fw-semibold px-5"
                            onClick={onSubmit1}
                          >
                            List on Marketplace
                          </button>
                        )}
                        {/* <p className="text-danger py-3" >{maticmainnet?"Please switch to Matic (Polygon) network":""}</p> */}
                      </div>
                      <p className="text-danger d-flex align-items-center justify-content-center gap-2 " >{maticmainnet ? <> Please switch to Matic (Polygon) network <Link className="text-decoration-none text-danger" to={'https://www.coindesk.com/learn/how-to-connect-metamask-to-the-polygon-network/'} target={'_blank'}><sup><i class="fa-solid fa-circle-info"></i></sup></Link> </> : ""}</p>
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Form>
          ) : (
            ""
          )}
        </Col>
      </Row>
    </>
  );
}
